import { UserWithAvatar } from "src/components/LogItem/components/UserWithAvatar";
import { actionsText } from "src/components/LogItem/utils/entityActions";
import { getLastActiveTime } from "src/helpers/datetimeHelper";
import { useUserById } from "src/hooks/useUserById";
import { Log } from "src/types.g";
import { capitalizeFirstLetter } from "src/utils";

interface LogItemProps {
  log: Log;
  onLogItemClick: (log: Log) => void;
}

export const LogItem = (props: LogItemProps): JSX.Element => {
  const { user } = useUserById({
    id: props.log.userId,
  });

  const handleLogItemClick = () => {
    props.onLogItemClick(props.log);
  };

  return (
    <tr className="log-item" onClick={handleLogItemClick}>
      <td className="user-avatar">
        <UserWithAvatar user={user} />
      </td>
      <td className="action">
        {capitalizeFirstLetter(actionsText[props.log.action!])}
      </td>
      <td className="timestamp">{getLastActiveTime(props.log.timestamp)}</td>
    </tr>
  );
};
